import { RangeKey } from './BirthdayService';

interface Props {
    today: Date;
    totalForRange: number;
    rangeKey: RangeKey;
}

const RANGE_PHRASE: Record<RangeKey, string> = {
    7: 'next 7 days',
    30: 'next 30 days',
    90: 'next 90 days',
    365: 'this year',
};

const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function formatTodayLong(d: Date): string {
    return `${d.getDate()} ${MONTH_SHORT[d.getMonth()]} ${d.getFullYear()}`;
}

const BirthdayHeader = ({ today, totalForRange, rangeKey }: Props) => {
    const dynamicClause =
        totalForRange === 0
            ? 'No upcoming birthdays in this range.'
            : `${totalForRange} birthdays in ${RANGE_PHRASE[rangeKey]}.`;

    return (
        <div className="d-flex flex-wrap align-items-start justify-content-between mb-4 bd-header">
            <div className="flex-1 me-3">
                <h2 className="font-26 font-600 mb-2">Upcoming birthdays</h2>
                <p className="font-16 font-400 text-gray-53 mb-0">
                    Stay close to your alumni community. {dynamicClause}
                </p>
            </div>
            <div className="bd-today-badge">
                <span className="bd-today-badge-label">Today</span>
                <span className="bd-today-badge-date">{formatTodayLong(today)}</span>
            </div>
        </div>
    );
};

export default BirthdayHeader;
